<template>
  <div class="container">
    <head-nav-bar title="医生介绍" :fixed="true" />
    <div class="mt-header-nav">
      <DataList api="Doctor_List">
        <template v-slot:item="item">
          <div class="doctor-item" @click="toInfo(item.obj)">
            <doctor-card :data="item.obj" />
          </div>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import DoctorCard from "@/components/DoctorCard";

export default {
  components: {
    DataList,
    DoctorCard
  },
  data() {
    return {
      info: {}
    };
  },
  created() {},
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "hospitalDoctorInfo",
        query: {
          Id: item.Id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
